import { RegionId } from "../types";

export const VOIVODESHIP_PL_NAMES: Record<RegionId, string> = {
  "PL-DS": "Dolnośląskie",
  "PL-KP": "Kujawsko-pomorskie",
  "PL-LB": "Lubuskie",
  "PL-LD": "Łódzkie",
  "PL-LU": "Lubelskie",
  "PL-MA": "Małopolskie",
  "PL-MZ": "Mazowieckie",
  "PL-OP": "Opolskie",
  "PL-PD": "Podlaskie",
  "PL-PK": "Podkarpackie",
  "PL-PM": "Pomorskie",
  "PL-SK": "Świętokrzyskie",
  "PL-SL": "Śląskie",
  "PL-WN": "Warmińsko-mazurskie",
  "PL-WP": "Wielkopolskie",
  "PL-ZP": "Zachodniopomorskie",
};

export const VOIVODESHIP_IDS: RegionId[] = Object.keys(
  VOIVODESHIP_PL_NAMES,
) as RegionId[];
